
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import { mapState } from 'vuex'
export default {
name: 'user',
props: [],
directives: {
TransferDom
},
components: {
XHeader,
Group,
XInput,
XButton,
Confirm
},
data () {
return {
status: 0,
isEdit: this.$route.params.isEdit,
isShow: false,
title: this.$route.meta.title,
alumnusList: [
{
id: 0,
label: '手机',
placeholder: '请填写您的手机',
type: 'tel',
isType: 'china-mobile',
value: ''
},
{
id: 1,
label: '邮箱',
placeholder: '请填写您的邮箱',
type: 'email',
isType: 'email',
value: ''
},
{
id: 2,
label: 'QQ',
placeholder: '请填写您的QQ',
type: 'number',
isType: '',
value: ''
},
{
id: 3,
label: '微信号',
placeholder: '请填写您的微信号',
type: 'number',
isType: '',
value: ''
}
],
resultMsg: {}
}
},
computed: {
...mapState({
studentId: state => state.userInfo.id,
flowId: state => state.flowInfo.flowId,
flowProcedureId: state => state.currentProcedureInfo.flowProcedureId,
procedureId: state => state.currentProcedureInfo.procedureId
})
},
created () {},
mounted () {

this.getProcedureStatus()
},
methods: {
back () {
if (this.isEdit) {
this.isShow = true
} else {
setTimeout(() => {
this.$router.back(-1)
}, 300)
}
},
save () {
let errorLength = document.getElementsByClassName('weui-cell weui-cell_warn').length
let flag
this.alumnusList.forEach(element => {
if (element.value !== '') {
flag = true
} else {
flag = false
}
})
if (flag && errorLength === 0) {
let params = {
id: this.studentId,
flowId: this.flowId,
flowProcedureId: this.flowProcedureId,
procedureId: this.procedureId,
phoneNumber: this.alumnusList[0].value,
email: this.alumnusList[1].value,
qq: this.alumnusList[2].value,
wechat: this.alumnusList[3].value
}
this.$api.post('/studentInfo', params,
r => {
setTimeout(() => {
this.$router.push({
name: 'itemResult',
params: {
title: this.title
}
})
}, 300)
},
err => {
this.$vux.toast.text(err.message, 'top')
})
} else {
this.$vux.toast.text('请填写正确的信息', 'middle')
}
},
getProcedureStatus () {
let params = {
studentId: this.studentId,
flowId: this.flowId,
procedureId: this.procedureId,
flowProcedureId: this.flowProcedureId
}
this.$api.get('/dataManagement/getDataManagementList', params,
r => {
this.$vux.loading.hide()
let data = r.data[0]
this.status = data.status
if (this.status === 4 && this.isEdit === false) {
this.$router.push({
name: 'itemResult',
params: {
title: this.title
}
})
}
},
err => {
this.$vux.toast.text(err.message, 'top')
})
},
onCancel () {
this.isShow = false
},
onConfirm () {
this.isShow = false
setTimeout(() => {
this.$router.back(-1)
}, 300)
}
}
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/views/items/alumnus.vue